categories = [
  'analytics-reporting'
  'automation'
  'board-utilities'
  'communication-collaboration'
  'developer-tools'
  'file-management'
  'hr-operations'
  'it-project-management'
  'marketing-social-media'
  'product-design'
  'sales-support'
]

featuredPlugins = {
  '55a5d917446f51777421000a': # Slack
    '@1x': require('images/directory/featured-hero/slack.jpg')
    '@2x': require('images/directory/featured-hero/slack@2x.jpg')
  '55a5d917446f517774210011':  # Calendar
    '@1x': require('images/directory/featured-hero/calendar.jpg')
    '@2x': require('images/directory/featured-hero/calendar@2x.jpg')
  '568c2b6c7d2758a55ac48c98': # Corrello
    '@1x': require('images/directory/featured-hero/corrello.png')
    '@2x': require('images/directory/featured-hero/corrello@2x.png')
  '55a5d915446f517774210002': # Dropbox
    '@1x': require('images/directory/featured-hero/dropbox.png')
    '@2x': require('images/directory/featured-hero/dropbox@2x.png')
  '5935cab6b26816f9d49fd814': # Butler
    '@1x': require('images/directory/featured-hero/butler.png')
    '@2x': require('images/directory/featured-hero/butler@2x.png')
  '56d5e249a98895a9797bebb9': # Custom Fields
    '@1x': require('images/directory/featured-hero/customfields.png')
    '@2x': require('images/directory/featured-hero/customfields@2x.png')
}

utmParams = 'utm_source=trello&utm_medium=directory&utm_campaign=featured'

featuredCarouselData = [
  {
    title: 'Customize Your Cards'
    body: 'Organize the information you need the way you want with the Custom Fields Power-Up.'
    image: require('images/directory/carousel/customize.png')
    link: "https://blog.trello.com/trello-custom-fields?#{utmParams}"
  }
  {
    title: 'Go-To-Market With Gusto'
    body: 'Maximize marketing team collaboration with these six Power-Ups.'
    image: require('images/directory/carousel/gusto.png')
    link: "https://blog.trello.com/go-to-market-strategy-in-trello?#{utmParams}"
  }
  {
    title: 'Go From Idea To MVP'
    body: 'A five Power-Up lineup to get your team to launch day faster.'
    image: require('images/directory/carousel/mvp.png')
    link: "https://blog.trello.com/idea-to-mvp-product-workflow-trello-power-ups?#{utmParams}"
  }
]

module.exports = {
  categories
  featuredPlugins
  featuredCarouselData
}



// WEBPACK FOOTER //
// ./app/scripts/data/directory.coffee